<mat-card>
  <mat-card-title>Choix d'une direction ou composante</mat-card-title>
  <mat-card-content>
    <div fxLayout="column">

      <div fxLayoutAlign="center" fxLayoutGap="20px" fxLayout="column" fxFlex="50">
        <span>Je veux sélectionner</span>

        <button fxFlex="20" mat-stroked-button (click)="onDirectionSelected($event)" matBadge="{{badgeDir}}" matBadgeOverlap="true"> une direction / service </button>
        <button fxFlex="20" mat-stroked-button (click)="onComposanteSelected($event)" matBadge="{{badgeCmp}}" matBadgeOverlap="true"> une composante / département </button>
      </div>
      <div>
        <div fxLayoutGap="20px">
          <mat-form-field *ngIf="labelDirCmp" fxFlex="90">
            <mat-select placeholder="{{labelDirCmp}}" [(ngModel)]="entiteSelected" name="composante"
                        (selectionChange)="searchDepartement($event.value)">
              <mat-option *ngFor="let entite of entitesList" [value]="entite">
                {{ entite.name }} ({{ entite.code }})
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field *ngIf="svcdepList && svcdepList.length > 0" fxFlex="90">
            <mat-select  placeholder="{{labelSvcDep}}" [(ngModel)]="svcdepSelected"
                        name="departement">
              <mat-option *ngFor="let svcdep of svcdepList" [value]="svcdep">
                {{ svcdep.name }} ({{ svcdep.code }})
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions align="end">
    <button mat-button [disabled]="!entiteSelected" (click)="select()">Choisir</button>
    <button mat-button (click)="close()">Fermer</button>

  </mat-card-actions>
  <mat-card-footer>
  </mat-card-footer>
</mat-card>

